import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '~/api-client';
import { useHandleSearchResponse } from '../search-windows/use-handle-search-response';
import { useEventSearchResultsPaginationContext } from './event-search-results-pagination-provider';
import { useEventSearchSortContext } from './event-search-sort-provider';
import { CadSearchsaveResource } from '@mark43/cad-api';
import { SavedSearchDateRangeForm } from '../search-windows/saved-search';

export function useExecuteSavedEventSearchQuery({
    tabId,
    savedSearchId,
    dateRangeOverride,
}: {
    tabId: number;
    savedSearchId?: number;
    dateRangeOverride?: SavedSearchDateRangeForm;
}) {
    const pagination = useEventSearchResultsPaginationContext();
    const sort = useEventSearchSortContext();
    const apiClient = useApiClient();
    const handleSearchResponse = useHandleSearchResponse(pagination);

    return useQuery(
        [
            'saved-event-search',
            tabId,
            savedSearchId,
            pagination.itemOffset,
            pagination.itemsPerPage,
            sort.sortByValue.value,
            sort.directionValue.value,
            dateRangeOverride,
        ] as const,
        ({ queryKey }) => {
            return apiClient
                .request<CadSearchsaveResource.ExecuteSavedEventSearch>({
                    method: 'POST',
                    url: 'cad_search/save/event/execute',
                    data: {
                        // query only enabled if savedSearchId exists
                        savedSearchId: queryKey[2]!,
                        showNewResults: false,
                        from: queryKey[3],
                        size: queryKey[4],
                        sortKey: queryKey[5],
                        sortType: queryKey[6],
                        dateRangeOverride: queryKey[7],
                    },
                })
                .then((resp) => {
                    const eventSearchResponse = resp.data.data;
                    handleSearchResponse(eventSearchResponse?.totalCount, queryKey[3]);
                    return eventSearchResponse;
                });
        },
        {
            enabled: !!savedSearchId,
        }
    );
}
